import { type RatePackage } from './rate-package';
import { type Operand } from './operand';

export class Packages {
  public RatePackages?: RatePackage[];
  public Operands?: Operand[];
  public Error?: any;
}
